import Mousetrap from 'mousetrap'
import { Draggable } from '@shopify/draggable'

;(function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .controller('ProductListController', ProductListController)

  /* @ngInject */
  function ProductListController ($rootScope, $scope, $state, $translate, $q, $timeout, $location, $stateParams, NewAssetService, MemoTemplateRequestService, Utils, CONSTANTS, ArtsService, ModalService, ConnectorWebService, MessageService, TemplateService, ArtCollectionsService, SegmentService, AssetPreviewService, UdsModalService, ToastService, FormatsService, TagsService, GroupService, FeatureReleaseNotificationsService, ConfirmationModalService, CampaignService, LocalStorageService, SocialMediaService, MaterialUploadService, SelectMaterialCollectionService) {
    const getCreateCampaignDialogController = () => $q.when(import('../../../admin/dialogs/create-campaign/create-campaign-dialog.controller'))
    const getDownloadDialogController = () => $q.when(import('../../dialogs/download/download-dialog.controller'))
    const getMergeArtsDialogController = () => $q.when(import('../../dialogs/merge-arts/merge-arts-dialog.controller'))
    const getMoveTemplateCollectionController = () => $q.when(import('../../dialogs/move-template-collection/move-template-collection-dialog.controller'))
    const getTemplateSuggestionsDialogController = () => $q.when(import('../../dialogs/template-suggestions/template-suggestions-dialog.controller'))
    const getImportSvgDialogController = () => $q.when(import('../../dialogs/import/import-dialog.controller'))
    const getArtSizeDialogController = () => $q.when(import('../../dialogs/art-size/art-size-dialog.controller'))
    const getAttachInsideTheModuleModalController = () => $q.when(import('../../../repository/directives/attach-inside-the-module-modal/attach-inside-the-module-modal.controller'))
    const getTemplatePropertiesDialogController = () => $q.when(import('../../dialogs/template-properties/template-properties-dialog.controller'))
    const getImportTemplateNoCustomizableController = () => $q.when(import('../../dialogs/import-template-no-customizable/import-template-no-customizable.controller'))
    const getSocialMediaIntegrationController = () => $q.when(import('../../dialogs/social-media-integration/social-media-integration.controller'))
    const getShareFolderDialogController = () => $q.when(import('../../../arts/dialogs/share-folder/share-folder-dialog.controller'))

    $scope.iTokensCount = $rootScope.isDesktop ? 3 : 5
    $scope.hideSearch = 0
    $scope.location = 'materials'
    $scope.floatingBarLocation = 'materials'
    $scope.selectedCollections = []
    $scope.selectedTemplates = []
    $scope.currentDropTargetFolderId = null
    $scope.sidebar = {
      selected: {},
      items: []
    }
    $scope.companyFeatures = {
      artsCustomization: {
        access: true
      }
    }
    $scope.flags = {
      loading: false,
      showFilter: false,
      loadingSections: true
    }
    $scope.campaign = {
      pagination: {
        top: 40
      },
      totalCount: 0,
      results: [],
      state: {
        loading: true,
        count: undefined
      }
    }
    $scope.search = {
      term: '',
      count: 0,
      pagination: {
        top: 10,
        skip: 0,
        collections: {
          top: 8,
          skip: 0
        },
        templates: {
          top: 8,
          skip: 0
        }
      },
      state: {
        term: '',
        searching: false,
        loading: false
      }
    }
    $scope.filters = {
      createdAtStart: null,
      createdAtEnd: null,
      templateExpirationStart: null,
      templateExpirationEnd: null
    }

    $scope.templateParam = {}
    $scope.collectionParam = {}

    $scope.selectedTemplate = null

    $scope.quickPreviewTemplate = null
    $scope.sectionLoading = false
    $scope.sectionTop = 5
    $scope.sectionSkip = 0
    $scope.loadingMoreSections = false
    $scope.filesTop = 10
    $scope.paginationTop = 20

    $scope.templateOptions = {
      edit: true,
      move: true,
      download: true,
      archive: true,
      share: true,
      settings: true,
      duplicate: true
    }
    $scope.publicFolderIsEnabled = false

    $scope.pageTitle = ''

    const handleTemplatePagination = MemoTemplateRequestService.handlePaginationMemo()

    const today = moment()
    let adminView = false

    $scope.filtersCount = 0

    const api = {
      getTemplatePropertiesDialogController,
      getCreateCampaignDialogController,
      getDownloadDialogController,
      getMergeArtsDialogController,
      getMoveTemplateCollectionController,
      getTemplateSuggestionsDialogController,
      getImportTemplateNoCustomizableController,
      getImportSvgDialogController,
      getArtSizeDialogController,
      getSocialMediaIntegrationController,
      getShareFolderDialogController,
      _handleCompanyFeatures,
      _showTemplateSuggestions,
      _getArtSections,
      _clearSearch,
      _getArtSectionsForSidebar,
      _initSearchArtsPage,
      _onSearchArts,
      _getSectionCollections,
      _getSectionTemplates,
      _getHighlightedCollections,
      _addInfiniteScroll,
      _openTemplatePropertiesDialog,
      _nextSearchPage,
      _checkEmptyValues,
      _checkIfPageExists,
      _handleQuickPreview,
      _handleOpenQuickPreview,
      _getSelectedTemplateSection,
      _handleKeyboardNavigation,
      _handleNavigateThroughKeyboard,
      _clearSelectedTemplate,
      _onFilter,
      _initHeader,
      _onSearch,
      _onCount,
      _handleEditMode,
      _showSocialMediaIntegrationModal,
      _openSocialMediaIntegration,
      _successGetSocialMediaIntegration,
      _errorGetSocialMediaIntegration,
      _hasNewIntegrationDate,
      _loadMoreFiles,
      _unselectAllTemplatesAndCollections,
      _unselectAllAndSelectNewItem,
      _addNewItemToSelectedItems,
      _unselectLastItemFromSelectedItems,
      _loadMoreCollectionsOnSearch,
      _loadMoreTemplatesOnSearch,
      _handleShiftClickOnTemplate,
      _handleShiftClickOnCollection,
      _initializeDraggable,
      _handleDraggableOn,
      _handleDraggableOff,
      _handleDraggableMirror,
      _initializeHoverLogger,
      _handleMoveMultipleDragging,
      _showCollectionHasExpirationConfirmation,
      _getTemplateTarget
    }
    this.getApi = () => api

    activate()

    function activate () {
      SegmentService.track('arts-template-pageview')

      $(document).scrollTop(0)

      if ($stateParams.previewId) {
        TemplateService.getTemplateById($stateParams.previewId).then((template) => {
          AssetPreviewService.openAssetPreview({
            asset: template,
            getPreviewAssets: $scope.getPreviewAssets
          })
        })
        delete $stateParams.previewId
      }

      api._handleCompanyFeatures()
        .then(() => {
          $rootScope.getUser()
            .then(() => {
              api._initHeader()

              adminView = $rootScope.isUserSysAdminAdminDesigner()
              api._getHighlightedCollections({ top: $scope.campaign.pagination.top, skip: 0, adminView }, 0, true)
            })
        })
      api._handleKeyboardNavigation()
      api._handleQuickPreview()
      api._getArtSectionsForSidebar()
      api._getArtSections({ top: $scope.sectionTop, skip: 0 })
      api._initSearchArtsPage($state.params)
      api._showSocialMediaIntegrationModal()
      $scope.$emit('headerSearch.placeholder', $translate.instant('templateSearch.placeholder'))

      $rootScope.getCompanyFeatures().then(features => {
        if (features.includes('PUBLIC_FOLDER')) {
          $scope.publicFolderIsEnabled = true
        }
      })
    }

    $scope.activateDraggable = (sectionId) => {
      $timeout(() => {
        api._initializeDraggable(sectionId)
        api._initializeHoverLogger()
      }, 0)
    }

    function _initializeDraggable (sectionId) {
      const section = document.querySelectorAll(`.section-${sectionId}`)

      section.forEach(container => {
        const draggable = new Draggable(container, {
          draggable: 'template-item, collection-item',
          handle: '.template-item-content-draggable, .collection-item-content-draggable',
          mirror: {
            appendTo: 'body',
            constrainDimensions: true
          }
        })

        draggable.on('drag:start', api._handleDraggableOn)
        draggable.on('drag:stop', api._handleDraggableOff)
        draggable.on('mirror:created', api._handleDraggableMirror)
        draggable.on('mirror:move', (event) => {
          const mirror = event.data.mirror
          mirror.style.opacity = '1'

          const allElements = mirror.querySelectorAll('*')
          allElements.forEach(element => {
            element.style.opacity = '1'
          })
        })
      })
    }

    function _initializeHoverLogger () {
      const folders = document.querySelectorAll('collection-item')
      const sections = document.querySelectorAll('.section-content-items.draggable-container')
      folders.forEach(folder => {
        folder.addEventListener('mouseenter', () => {
          const selectedSection = document.querySelectorAll('.section-content-items.draggable-container.hover-section-dragging')
          $scope.currentDropTargetFolderId = null
          if (selectedSection.length) {
            selectedSection.forEach(section => {
              section.classList.remove('hover-section-dragging')

              const cardsInPreviousSection = section.querySelectorAll('template-item:not(.selected-template), collection-item:not(.selected-collection)')
              cardsInPreviousSection.forEach(card => {
                const wrapperCard = card.querySelector('.wrapper-card')
                if (wrapperCard) {
                  wrapperCard.style.filter = null
                }
              })
            })
          }

          const folderIdWithText = folder.children[0].getAttribute('data-id')
          const folderId = folderIdWithText.replace('collection-item-', '')
          const folderName = folder.children[0].getAttribute('data-name')
          const folderNameWithoutSpaces = folderName.trim()
          $scope.currentDropTargetFolderName = folderNameWithoutSpaces
          $scope.currentDropTargetFolderId = folderId
          if ($scope.draggedItemIds && $scope.currentDropTargetFolderId) {
            folder.children[0].style.border = '1px solid #0d94ff'
            folder.children[0].style.outline = '1px solid #0d94ff'
            folder.children[0].style.zIndex = '9600'
            folder.children[0].style.position = 'relative'
          }
        })

        folder.addEventListener('mouseleave', () => {
          $scope.currentDropTargetFolderId = null
          $scope.currentDropTargetFolderName = null
          folder.children[0].style.border = null
          folder.children[0].style.outline = null
          folder.children[0].style.transform = null
          folder.children[0].style.transition = null
          folder.children[0].style.zIndex = null
          folder.children[0].style.position = null

          const hoveredSection = document.querySelectorAll('.section-content-items.draggable-container.hover-section')
          if (hoveredSection.length) {
            const sectionId = hoveredSection[0].getAttribute('data-id')
            $scope.currentDropTargetFolderId = sectionId
            $scope.currentDropTargetFolderName = hoveredSection[0].getAttribute('data-name').trim()
            hoveredSection.forEach(section => {
              section.classList.add('hover-section-dragging')

              const cardsInSection = section.querySelectorAll('template-item:not(.selected-template), collection-item:not(.selected-collection)')
              cardsInSection.forEach(card => {
                const wrapperCard = card.querySelector('.wrapper-card')
                if (wrapperCard) {
                  wrapperCard.style.filter = 'blur(1.5px) brightness(0.95)'
                }
              })

              const selectedCards = section.querySelectorAll('template-item.selected-template, collection-item.selected-collection')
              selectedCards.forEach(card => {
                card.style.position = 'relative'
                card.style.zIndex = '9999'
              })
            })
          }
        })
      })
      sections.forEach(section => {
        section.addEventListener('mouseenter', () => {
          const sectionId = section.getAttribute('data-id')
          $scope.currentDropTargetFolderId = sectionId
          $scope.currentDropTargetFolderName = section.getAttribute('data-name').trim()
          if ($scope.draggedItemIds && $scope.currentDropTargetFolderId) {
            section.classList.add('hover-section-dragging')
            section.classList.add('hover-section')

            const cardsInSection = section.querySelectorAll('template-item:not(.selected-template), collection-item:not(.selected-collection)')
            cardsInSection.forEach(card => {
              card.style.zIndex = '1'
              const wrapperCard = card.querySelector('.wrapper-card')
              if (wrapperCard) {
                wrapperCard.style.filter = 'blur(1.5px) brightness(0.95)'
              }
            })

            const selectedCards = section.querySelectorAll('template-item.selected-template, collection-item.selected-collection')
            selectedCards.forEach(card => {
              card.style.position = 'relative'
              card.style.zIndex = '9999'
            })
          }
        })

        section.addEventListener('mouseleave', () => {
          $scope.currentDropTargetFolderId = null
          section.classList.remove('hover-section-dragging')
          section.classList.remove('hover-section')

          const cardsInSection = section.querySelectorAll('template-item, collection-item')
          cardsInSection.forEach(card => {
            card.style.zIndex = ''
            const wrapperCard = card.querySelector('.wrapper-card')
            if (wrapperCard) {
              wrapperCard.style.filter = null
            }
          })
        })
      })
    }

    function _handleDraggableOn (event) {
      api._initializeHoverLogger()
      const selectedTemplates = document.querySelectorAll('.template-item-directive.selected-template')
      const selectedCollections = document.querySelectorAll('.collection-item.selected-collection')
      const sourceElement = event.data.source

      sourceElement.setAttribute('data-is-dragging', 'true')

      if (selectedTemplates.length || selectedCollections.length) {
        selectedTemplates.forEach(card => {
          card.style.position = 'relative'
          card.style.zIndex = '9999'
          card.children[0].style.opacity = '0.5'
        })

        selectedCollections.forEach(card => {
          card.style.position = 'relative'
          card.style.zIndex = '9999'
          card.style.opacity = '0.5'
        })
      } else {
        sourceElement.style.position = 'relative'
        sourceElement.style.zIndex = '9999'
        sourceElement.children[0].style.opacity = '0.5'
      }

      if (selectedTemplates.length > 1 || selectedCollections.length > 1) {
        const templatesIds = Array.from(selectedTemplates).reduce((ids, card) => {
          const cardId = card.getAttribute('data-id')
          if (!ids.includes(cardId)) {
            ids.push(cardId)
          }
          return ids
        }, [])

        const collectionsIds = Array.from(selectedCollections).reduce((ids, card) => {
          const cardIdWithText = card.getAttribute('data-id')
          const cardId = cardIdWithText.replace('collection-item-', '')
          if (!ids.includes(cardId)) {
            ids.push(cardId)
          }
          return ids
        }, [])

        $scope.draggedItemIds = {
          templates: templatesIds,
          collections: collectionsIds
        }
      } else {
        if (sourceElement.children[0].classList.contains('template-item-directive')) {
          const draggedCardId = event.data.originalSource.firstChild.dataset.id
          if (draggedCardId) {
            $scope.draggedItemIds = {
              templates: [draggedCardId],
              collections: []
            }
          }
        } else {
          const draggedCardIdWithText = event.data.originalSource.firstChild.dataset.id
          const draggedCardId = draggedCardIdWithText.replace('collection-item-', '')
          if (draggedCardId) {
            $scope.draggedItemIds = {
              templates: [],
              collections: [draggedCardId]
            }
          }
        }
      }
    }

    function _handleDraggableOff (event) {
      const selectedCards = document.querySelectorAll('.template-item-directive.selected-template')
      const selectedCollections = document.querySelectorAll('.collection-item.selected-collection')
      const draggingElements = document.querySelectorAll('[data-is-dragging="true"]')

      draggingElements.forEach(element => {
        element.removeAttribute('data-is-dragging')
      })

      if (selectedCards.length || selectedCollections.length) {
        selectedCards.forEach(card => {
          card.style.position = ''
          card.style.zIndex = ''
          card.children[0].style.opacity = '1'
        })

        selectedCollections.forEach(card => {
          card.style.position = ''
          card.style.zIndex = ''
          card.style.opacity = '1'
        })
      } else if (event.data.source) {
        event.data.source.style.position = ''
        event.data.source.style.zIndex = ''
        event.data.source.children[0].style.opacity = '1'
      }

      const allCards = document.querySelectorAll('template-item, collection-item')
      allCards.forEach(card => {
        card.style.position = ''
        card.style.zIndex = ''
        const wrapperCard = card.querySelector('.wrapper-card')
        if (wrapperCard) {
          wrapperCard.style.filter = null
          wrapperCard.style.boxShadow = null
          wrapperCard.style.transform = null
          wrapperCard.style.opacity = '1'
        }
      })

      const allSections = document.querySelectorAll('.section-content-items.draggable-container')
      allSections.forEach(section => {
        section.classList.remove('hover-section-dragging')
        section.classList.remove('hover-section')
      })

      if ($scope.draggedItemIds && $scope.currentDropTargetFolderId) {
        api._handleMoveMultipleDragging($scope.currentDropTargetFolderId)
      }
      $scope.draggedItemIds = null
      $scope.currentDropTargetFolderId = null
      event._canceled = true
    }

    function _handleDraggableMirror (event) {
      const mirror = event.data.mirror
      const count = $scope.draggedItemIds.templates.length + $scope.draggedItemIds.collections.length

      mirror.style.position = 'fixed'
      mirror.style.zIndex = '10000'
      mirror.style.opacity = '1'

      mirror.setAttribute('data-is-mirror', 'true')

      const wrapperCard = mirror.querySelector('.wrapper-card')
      if (wrapperCard) {
        wrapperCard.style.opacity = '1'
        wrapperCard.style.filter = 'none'
        wrapperCard.style.boxShadow = '0 5px 15px rgba(0,0,0,0.2)'
      }

      const allElements = mirror.querySelectorAll('*')
      allElements.forEach(element => {
        element.style.opacity = '1'
        element.style.filter = 'none'
      })

      mirror.classList.add('card-mirror')

      if (count) {
        mirror.classList.add('mirror-with-counter')
        mirror.setAttribute('data-count', count)
      }

      setTimeout(() => {
        mirror.style.opacity = '1'
        if (wrapperCard) {
          wrapperCard.style.opacity = '1'
        }
        allElements.forEach(element => {
          element.style.opacity = '1'
        })
      }, 0)
    }

    async function _handleMoveMultipleDragging (targetId) {
      const promises = []
      const targetIdNumber = Number(targetId)
      const templateIds = $scope.draggedItemIds.templates.map(id => Number(id))
      const collectionIds = $scope.draggedItemIds.collections
        .map(id => Number(id))
        .filter(id => id !== targetIdNumber)
      const targetName = $scope.currentDropTargetFolderName

      const selectedOption = await ArtCollectionsService.find(targetIdNumber, {
        skipArchived: true
      })

      let sectionId = null

      if ($scope.selectedTemplates.length + $scope.selectedCollections.length > 1) {
        if ($scope.selectedTemplates.length) {
          sectionId = $scope.selectedTemplates[0].artCollectionId
          const { showDataWarning, showCollectionWarning, campaignName } = CampaignService.shouldShowCampaignWarningMultipleData($scope.selectedTemplates, selectedOption)
          if (showCollectionWarning) {
            CampaignService.showCollectionCampaignWarning()
            $scope.loadingButton = false
            return
          } else if (showDataWarning) {
            CampaignService.showDataCampaignWarning(campaignName)
            $scope.loadingButton = false
            return
          }

          promises.push(TemplateService.moveMultipleTemplates(templateIds, targetIdNumber).then(() => {
            const target = api._getTemplateTarget(selectedOption)
            templateIds.forEach(templateId => {
              SegmentService.track('arts-template-move', { art_id: templateId, target: target })
            })
          }))
        }

        if ($scope.selectedCollections.length) {
          sectionId = $scope.selectedCollections[0].parentId
          const { showDataWarning, showCollectionWarning, campaignName } = CampaignService.shouldShowCampaignWarningMultipleData($scope.selectedCollections, selectedOption)
          if (showCollectionWarning) {
            CampaignService.showCollectionCampaignWarning()
            $scope.loadingButton = false
            return
          } else if (showDataWarning) {
            CampaignService.showDataCampaignWarning(campaignName)
            $scope.loadingButton = false
            return
          }

          promises.push(ArtCollectionsService.moveMultipleArtCollection(collectionIds, targetIdNumber).then(() => {
            collectionIds.forEach(collectionId => {
              SegmentService.track('arts-collection-move', { collection_id: collectionId })
            })
          }))
        }
      } else {
        if (templateIds.length === 1) {
          const template = await TemplateService.getTemplateById(templateIds[0])

          sectionId = template.artCollectionId
          const { showDataWarning, showCollectionWarning, campaignName } = CampaignService.shouldShowCampaignWarning(template, selectedOption, $scope.isUnarchiving)
          if (showCollectionWarning) {
            CampaignService.showCollectionCampaignWarning()
            $scope.loadingButton = false
            return
          } else if (showDataWarning) {
            CampaignService.showDataCampaignWarning(campaignName)
            $scope.loadingButton = false
            return
          }

          promises.push(TemplateService.moveTemplate(template.id, targetIdNumber).then(() => {
            const target = api._getTemplateTarget(selectedOption)
            SegmentService.track('arts-template-move', { art_id: template.id, target: target })
          }))
        }

        if (collectionIds.length === 1) {
          const collection = await ArtCollectionsService.find(collectionIds[0], {
            skipArchived: true
          })

          sectionId = collection.parentId

          if (collection.id === targetIdNumber || collection.parentId === targetIdNumber) {
            return
          }

          const { showDataWarning, showCollectionWarning, campaignName } = CampaignService.shouldShowCampaignWarning(collection, selectedOption, $scope.isUnarchiving)

          if (showCollectionWarning) {
            CampaignService.showCollectionCampaignWarning()
            return
          } else if (showDataWarning) {
            CampaignService.showDataCampaignWarning(campaignName)
            return
          }

          promises.push(ArtCollectionsService.moveArtCollection(collection.id, targetIdNumber).then(() => {
            SegmentService.track('arts-collection-move', { collection_id: collection.id })
          }))
        }
      }

      const moveMultiple = () => {
        if (promises.length === 0) {
          return
        }
        $q.all(promises).then(() => {
          ToastService.showSuccessToast($translate.instant('successMoveArtToast', { sectionName: targetName }))
          $scope.$emit('refresh-arts-page', {
            targetId: targetIdNumber,
            sectionId: sectionId
          })
        }).catch(() => {
          ToastService.showErrorToast($translate.instant('errorMoveArtToast'))
        })
      }

      ArtCollectionsService.collectionHasExpiration(targetIdNumber).then(hasExpiration => {
        if (hasExpiration) {
          api._showCollectionHasExpirationConfirmation(moveMultiple)
        } else {
          moveMultiple()
        }
      })
    }

    async function _getTemplateTarget (selectedOption) {
      let target = null
      if (selectedOption.highlighted) {
        target = 'featured collection'
      } else if (selectedOption.parentId) {
        const parent = await ArtCollectionsService.find(selectedOption.parentId, {
          skipArchived: true
        })

        if (parent.parentId) {
          target = 'sub-collection'
        } else {
          target = 'collection'
        }
      } else {
        target = 'section'
      }

      return target
    }

    function _showCollectionHasExpirationConfirmation (callback) {
      ConfirmationModalService.createModal({
        title: $translate.instant('warning'),
        htmlDescription: $translate.instant('moveArtCollectionHasExpirationConfirmation'),
        buttonConfirmText: $translate.instant('yesContinueConfirmationButton'),
        buttonCancelText: $translate.instant('cancel'),
        onConfirm: () => {
          callback()
        }
      })
    }

    $scope.onLastSectionLoad = function () {
      $timeout(() => {
        if ($stateParams.section) {
          const marginTop = 170 // margin for the page's header
          const section = $('#section-' + $stateParams.section)[0]

          if (section) {
            $('.content-container-two-menu').animate({
              scrollTop: $(section).offset().top - marginTop
            }, 800)
            $stateParams.section = null
          } else {
            $scope.loadMoreSections()
          }
        }
      }, 700)

      $timeout(() => {
        $('.add-dropdown').dropdown()
        api._addInfiniteScroll()
        $scope.flags.loadingSections = false
      }, 2000, false)
    }

    const deregisterReloadArtsPage = $scope.$on('reload-arts-page', () => {
      api._unselectAllTemplatesAndCollections()
      $scope.sectionTop = 5
      $scope.campaign.pagination.top = 40
      $scope.sidebar = {
        selected: {},
        items: []
      }

      if ($scope.search.state.searching) {
        if ($scope.search.templates.length > 1 || $scope.search.collections.length > 1) {
          $scope.search.pagination.skip = $scope.search.pagination.top * $state.params.page || 0
          api._onSearchArts($scope.search.state.term, $scope.filters, $state.params.page)
        } else {
          $scope.search.pagination.skip = 0
          $scope.indexToken = 0
          api._onSearchArts($scope.search.state.term, $scope.filters, 0)
        }
      } else {
        api._getArtSections({ top: $scope.sectionTop, skip: 0 }, true)
        api._getArtSectionsForSidebar()
        api._getHighlightedCollections({ top: $scope.campaign.pagination.top, skip: 0, adminView }, 0, true)
      }
    })

    const deregisterRefreshArtsPage = $scope.$on('refresh-arts-page', (event, params) => {
      const { sectionId = null, targetId = null } = params
      api._unselectAllTemplatesAndCollections()

      if (sectionId) {
        const section = $scope.sections.find(section => section.id === sectionId)
        if (section) {
          section.index = 0
          section.order = Number(section.order)
          section.collections = []
          section.templates = []
          const promises = []
          promises.push(api._getSectionCollections(section, 0, false, true))
          promises.push(api._getSectionTemplates(section, 0, false, true))
          $q.all(promises).then(() => {
            section.filesCount = section.totalCollections + section.totalTemplates
          })
        }
      }

      if (targetId) {
        const sectionTarget = $scope.sections.find(section => section.id === targetId)
        if (sectionTarget) {
          sectionTarget.index = 0
          sectionTarget.order = Number(sectionTarget.order)
          sectionTarget.collections = []
          sectionTarget.templates = []

          const promises = []
          promises.push(api._getSectionCollections(sectionTarget, 0, false, true))
          promises.push(api._getSectionTemplates(sectionTarget, 0, false, true))
          $q.all(promises).then(() => {
            sectionTarget.filesCount = sectionTarget.totalCollections + sectionTarget.totalTemplates
          })
        }
      }
    })

    $scope.$on('$destroy', () => {
      deregisterReloadArtsPage()
      deregisterRefreshArtsPage()
      Mousetrap.unbind('space')
      document.removeEventListener('keydown', api._handleNavigateThroughKeyboard)
      AssetPreviewService.closePreview()
    })

    $scope.getPreviewAssets = (section, top, skip, startFromId, previewSort) => {
      const deferred = $q.defer()
      ArtCollectionsService.getTemplatesById(section, { top, skip, startFromId, previewSort }).then((res) => {
        deferred.resolve({
          assets: res.rows,
          count: res.count
        })
      })

      return deferred.promise
    }

    $scope.getPreviewAssetsSearch = (section, top, skip, startFromId, previewSort) => {
      const deferred = $q.defer()
      const state = $scope.search.state
      state.term = $scope.search.state.term

      ArtsService.search(state.term, top, skip, $scope.filters, startFromId, previewSort).then(res => {
        deferred.resolve({
          assets: res.rows,
          count: res.count
        })
      })

      return deferred.promise
    }

    $scope.openImportModal = function (sectionId) {
      api.getImportSvgDialogController().then(({ ImportSvg }) => {
        const addCompanyDialog = UdsModalService.createModal({
          controller: ImportSvg,
          modalName: 'importDialog',
          data: {
            artCollectionId: sectionId
          }
        })

        addCompanyDialog.open()
      })
    }

    $scope.openImportTemplate = (collectionId) => {
      getAttachInsideTheModuleModalController().then(({ AttachInsideTheModuleModalController }) => {
        const attachInsideTheModuleModal = UdsModalService.createModal({
          controller: AttachInsideTheModuleModalController,
          modalName: 'attachInsideTheModuleModal',
          data: {
            selectedTab: 'recents',
            location: 'materials',
            avoidSuccessOnConfirm: true
          },
          onClose: async (assetsToAttach) => {
            if (!assetsToAttach?.length) {
              return
            }

            api._openTemplatePropertiesDialog(assetsToAttach, collectionId)
          }
        })

        attachInsideTheModuleModal.open()
      })
    }

    function _getArtSectionsForSidebar () {
      ArtCollectionsService.getArtSections({ top: 100, skip: 0 }).then(sections => {
        $rootScope.isSecondLevelSidebarExpanded = sections.count > 0

        if (!sections.rows.length) {
          return
        }

        $scope.sidebar.items.push({
          name: 'brand.sections',
          row: sections.rows.map(row => {
            return { id: row.id, title: row.title }
          })
        })
      })
    }

    function _getArtSections (params, forceUpdate) {
      $scope.sectionLoading = true
      return new Promise((resolve) => {
        handleTemplatePagination(params.skip, {
          requestCallback: (cache) => {
            ArtCollectionsService.getArtSections(params).then(sections => {
              $scope.sectionLoading = false
              $scope.areThereTemplates = false
              if (sections.count) {
                $scope.sectionsCount = sections.count
              }

              if (params.merge) {
                $scope.sections = [...$scope.sections, ...sections.rows]
              } else {
                $scope.sections = sections.rows
              }

              sections.rows.forEach(section => {
                section.isExpanded = true
                section.filesCount = 0
                section.index = 0

                if (section.order) {
                  section.order = Number(section.order)
                }

                api._getSectionCollections(section, 0, true)
                api._getSectionTemplates(section, 0, true)
              })

              cache[params.skip] = $scope.sections
              resolve()
            })
          },
          cacheCallback: (cache, updateItems, removeItems) => {
            const selectedSection = {}
            const selectedCache = cache[params.skip]

            selectedCache.forEach((section, index) => {
              const templates = section.templates.find(template => template.id === $scope.templateParam.id)
              const collections = section.collections.find(collection => collection.id === $scope.collectionParam.id)
              if (templates) {
                selectedSection.template = index
              }

              if (collections) {
                selectedSection.collection = index
              }
            })

            const updateCacheItems = (key, updateItem = 'name') => {
              const cachedItems = cache[params.skip][selectedSection[key]][`${key}s`]
              const updatedItems = updateItems($scope[`${key}Param`].id, cachedItems, key, updateItem)
              const updatedCacheItems = removeItems(updatedItems, `archived-${key}`, 'id')

              const actualFilesCount = $scope.sections[selectedSection[key]].filesCount

              $timeout(() => {
                $scope.sections[selectedSection[key]][`${key}s`] = []
              }, 0, true)

              $timeout(() => {
                $scope.sections[selectedSection[key]][`${key}s`].push(...updatedCacheItems)
                $scope.sections[selectedSection[key]].filesCount = actualFilesCount - (updatedItems.length - updatedCacheItems.length)
              }, 0, false)

              cache[params.skip] = $scope.sections
            }

            if (selectedSection.template >= 0) {
              updateCacheItems('template')
            }

            if (selectedSection.collection >= 0) {
              updateCacheItems('collection', 'title')
            }

            $scope.sectionLoading = false

            resolve()
          }
        }, forceUpdate)
      })
    }

    $scope.hasVisibleSections = function () {
      if (!$scope.sections) {
        return false
      }

      return $scope.sections.some(section => section.filesCount && section.filesCount > 0)
    }

    $scope.onImgLoadError = function () {
      return '/assets/img/icons/img-placeholder.png'
    }

    $scope.getThumbnailUrl = product => {
      if (product.template.isCustomizable || product.template.thumbnailContentType || product.template.hasCover) {
        product.defaultThumb = false
        let url = Utils.fnReplaceStringParams(CONSTANTS.URL_PRODUCTS_ID_THUMBNAIL, [product.id])
        url += '?' + product.updatedAt
        return url
      } else if (product.template && product.template.extension) {
        product.defaultThumb = true
        return TemplateService.getDefaultThumbnail(product.template.extension)
      } else {
        return $scope.onImgLoadError()
      }
    }

    $scope.openItem = function (item) {
      let root = null
      if (item.parentId && !item.highlighted) {
        root = item.parentId
      }

      $rootScope.$emit('arts.clear-arts-filters')
      $state.go('arts.collection', {
        id: item.id,
        pageHistory: [],
        root
      })
    }

    $scope.getArtCollectionThumbnail = campaign => {
      if (campaign.random_template.isCustomizable || campaign.random_template.thumbnailContentType || campaign.random_template.hasCover || campaign.thumbnailS3Key) {
        campaign.defaultThumb = false
        const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_THUMBNAIL, [campaign.id])
        const cached = Utils.fnAddQueryToUrl(url, { cache: campaign.updatedAt })
        return cached
      } else {
        campaign.defaultThumb = true
        return TemplateService.getDefaultThumbnail(campaign.random_template.extension)
      }
    }

    $scope.getTemplateThumbnailUrl = function (template) {
      if (template.isCustomizable || template.thumbnailContentType || template.hasCover) {
        template.defaultThumb = false
        const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TEMPLATES_ID_THUMBNAIL, [template.id])
        const cached = Utils.fnAddQueryToUrl(url, { cache: template.updatedAt })

        return cached
      } else {
        template.defaultThumb = true
        return TemplateService.getDefaultThumbnail(template.extension)
      }
    }

    $scope.getProductThumbnailUrl = function (product) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_PRODUCT_ID_THUMBNAIL, [product.id])

      return url
    }

    $scope.nextSearchPage = api._nextSearchPage

    function _clearSearch () {
      $scope.search = {
        results: [],
        count: 0,
        pagination: {
          top: 20,
          skip: 0,
          collections: {
            top: 8,
            skip: 0
          },
          templates: {
            top: 8,
            skip: 0
          }
        },
        state: {
          term: '',
          searching: false,
          loading: false
        }
      }
      $location.search({ ...$state.params, search: null })
    }

    $scope.handleTemplateActionClick = function (product, template, operation) {
      if (!$rootScope.isDesktop && operation === 'CUSTOMIZE') {
        $scope.showMobileDialog()
        return
      }

      if (template.linkedTemplates && template.linkedTemplates.length > 0) {
        $scope.openMergeArtsDialog(product, template)
      } else if (!template.isCustomizable) {
        $scope.downloadAssetTemplate(product, template)
      } else if ((template.customizationLevel === 'ONLY_DOWNLOAD' && $rootScope.isUser()) || operation === 'DOWNLOAD') {
        $scope.openDownloadDialog(template)
      } else if (operation === 'CUSTOMIZE') {
        $state.go('customizeTemplate', {
          templateId: template.id,
          from: $state.current.name,
          fromParams: $state.params
        })
      }
    }

    $scope.showMobileDialog = function () {
      MessageService.error({
        title: $translate.instant('oopsTitle'),
        text: $translate.instant('mobileCustomizeNotAllowed') + '\n\n' + $translate.instant('continueWorkOnPC'),
        confirmButtonText: $translate.instant('ok')
      })
    }

    $scope.openMergeArtsDialog = function (product, template) {
      api.getMergeArtsDialogController().then(({ MergeArtsDialogController }) => {
        ModalService.showModal({
          templateId: 'mergeArtsDialog.html',
          templateUrl: '/arts/dialogs/merge-arts/merge-arts-dialog.html?$$REVISION$$',
          destroyable: true,
          controller: MergeArtsDialogController,
          data: {
            template: template,
            linkedTemplates: template.linkedTemplates.slice()
          }
        })
          .then(isDownloaded => {
            if (isDownloaded) {
              api._showTemplateSuggestions(product, template)
            }
          })
      })
    }

    $scope.openDownloadDialog = function (oTemplate) {
      ConnectorWebService.get(Utils.fnReplaceStringParams(CONSTANTS.URL_TEMPLATES_ID, [oTemplate.id])).then(function (templ) {
        api.getDownloadDialogController().then(({ DownloadDialogController }) => {
          const downloadDialog = UdsModalService.createModal({
            controller: DownloadDialogController,
            modalName: 'downloadDialog',
            data: {
              _iArtId: oTemplate.id,
              _sDownloadOption: oTemplate.downloadOption,
              _oTemplate: templ,
              _customizationLevel: oTemplate.customizationLevel,
              _isCustomizable: oTemplate.isCustomizable
            }
          })

          downloadDialog.open()
        })
      })
    }

    $scope.downloadAssetTemplate = function (oProduct, oTemplate) {
      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_ARTS_DOWNLOAD, [oTemplate.id])
      api._showTemplateSuggestions(oProduct, oTemplate)
      return Utils.downloadFile(url, {
        artId: oTemplate.id
      })
    }

    $scope.goBackToTemplates = function () {
      $location.search({})
      $state.go('arts.templates', {}, { reload: true, inherit: false })
    }

    $scope.moveCarrolsselClick = function (direction) {
      const carrossel = $('.campaigns-item-list')
      let value
      if (direction === 'left' && $rootScope.isDesktop) {
        value = '-=375'
      } else if (direction === 'right' && $rootScope.isDesktop) {
        value = '+=375'
      } else if (direction === 'left' && !$rootScope.isDesktop) {
        value = '-=281'
      } else {
        value = '+=281'
      }

      carrossel.animate({ scrollLeft: value }, 500, 'swing')
    }

    $scope.shouldShowArrows = function () {
      const carrossel = $('.campaigns-item-list')[0]
      let campaignsWidth
      if ($rootScope.isDesktop) {
        campaignsWidth = 375
      } else {
        campaignsWidth = 281
      }

      if (!carrossel) {
        return false
      }

      const campaignsShowing = Math.floor(carrossel.clientWidth / campaignsWidth)
      const campaigns = [...$scope.campaign.results]

      campaigns.forEach(campaign => {
        if (!$rootScope.isUserSysAdminAdminDesigner() && (campaign.isScheduled || !campaign.countTemplates)) {
          const index = campaigns.findIndex(item => item.id === campaign.id)
          if (index !== -1) {
            campaigns.splice(index, 1)
          }
        }
      })

      if (!campaigns.length || $scope.search.state.searching) {
        return false
      }

      return campaigns.length > campaignsShowing
    }

    $scope.changeIsExpanded = function (group, event) {
      if (event) {
        event.stopPropagation()
      }
      group.isExpanded = !group.isExpanded
    }

    $scope.changeToEditMode = api._handleEditMode

    $scope.loadMoreSections = function () {
      $scope.loadingMoreSections = true
      $scope.sectionTop = 5
      $scope.sectionSkip = $scope.sectionSkip + 1
      api._getArtSections({ top: $scope.sectionTop, skip: $scope.sectionTop * $scope.sectionSkip, merge: true }).then(() => {
        $scope.loadingMoreSections = false
      })
    }

    $scope.preventAccordionActivation = function (event) {
      event.stopPropagation()
    }

    $scope.loadMore = function (section) {
      api._loadMoreFiles(section)
    }

    $scope.loadMoreCollectionsOnSearch = function () {
      api._loadMoreCollectionsOnSearch()
    }

    $scope.loadMoreTemplatesOnSearch = function () {
      api._loadMoreTemplatesOnSearch()
    }

    async function _loadMoreCollectionsOnSearch () {
      const filters = $scope.filters
      const state = $scope.search.state
      const term = state.term
      const pagination = $scope.search.pagination.collections
      state.loadingCollections = true
      pagination.skip += 8

      ArtCollectionsService.searchArtCollections(term, pagination.top, pagination.skip, false, false, filters).catch((err) => {
        state.loadingCollections = false
        ToastService.defaultErrorToast()
        console.error(err)
      }).then(collections => {
        $scope.search.collections.push(...collections.rows)
      }).finally(() => {
        state.loadingCollections = false
      })
    }

    async function _loadMoreTemplatesOnSearch () {
      const filters = $scope.filters
      const state = $scope.search.state
      const term = state.term
      const pagination = $scope.search.pagination.templates
      state.loadingTemplates = true
      pagination.skip += 8

      ArtsService.search(term, pagination.top, pagination.skip, filters).catch((err) => {
        ToastService.defaultErrorToast()
        console.error(err)
      }).then(templates => {
        $scope.search.templates.push(...templates.rows)
      }).finally(() => {
        state.loadingTemplates = false
      })
    }

    async function _loadMoreFiles (section) {
      section.loadingMore = true
      section.index++
      await $q.all([
        api._getSectionCollections(section, section.index, false),
        api._getSectionTemplates(section, section.index, false)
      ])

      section.loadingMore = false
    }

    $scope.addCollectionClick = function (artCollectionId) {
      api.getCreateCampaignDialogController().then(({ CreateCampaignDialogController }) => {
        ModalService.showModal({
          templateId: 'createCampaign.html',
          templateUrl: '/admin/dialogs/create-campaign/create-campaign-dialog.html?$$REVISION$$',
          destroyable: true,
          observeChanges: true,
          allowMultiple: true,
          controller: CreateCampaignDialogController,
          data: {
            artCollectionId,
            showHightlightOption: true
          }
        }).then(changed => {
          if (changed) {
            $scope.loadingMoreSections = true
            $scope.sectionSkip = 0
            $scope.sectionsCount = 0

            api._getArtSections({ top: $scope.sectionTop, skip: 0 }, true).then(() => {
              $scope.loadingMoreSections = false
            })
            api._getHighlightedCollections({ top: $scope.campaign.pagination.top, skip: 0 }, 0, true)
          }
        })
      })
    }

    $scope.removeHighlightCollectionClick = function (collection) {
      const oldModalReference = ModalService.getCurrentModal()

      return api.getMoveTemplateCollectionController().then(({ MoveTemplateCollectionController }) => {
        ModalService.showModal({
          templateId: 'moveTemplateCollection.html',
          templateUrl: '/arts/dialogs/move-template-collection/move-template-collection-dialog.html?$$REVISION$$',
          destroyable: true,
          observeChanges: true,
          allowMultiple: true,
          controller: MoveTemplateCollectionController,
          data: {
            data: collection,
            type: 'collection',
            onlyTarget: true
          }
        }).then(info => {
          if (oldModalReference) {
            ModalService.setCurrentModal(oldModalReference)
            ModalService.showCurrentModal()
          }
          if (info && info.artCollectionId) {
            ArtCollectionsService.highlightArtCollection(collection.id, false, info.artCollectionId).catch(ToastService.defaultErrorToast).then(() => {
              SegmentService.track('arts-collection-highlight', { collection_id: collection.id, is_highlight: false })
              ModalService.close(true)
              $scope.$emit('reload-arts-page')
              $scope.sidebar = {
                selected: {},
                items: []
              }

              activate()
            })
          } else {
            ModalService.close()
          }
        })
      })
    }

    $scope.archiveCollectionClick = function (collection) {
      const modalConfig = {
        title: $translate.instant('archive'),
        buttonCancelText: $translate.instant('cancel'),
        buttonConfirmText: $translate.instant('campaignEdit.archiveConfirm.confirm'),
        onConfirm: () => {
          ArtCollectionsService.archiveArtCollection(collection.id).then(() => {
            ToastService.defaultSuccessToast()
            $scope.sectionTop = 5
            $scope.campaign.pagination.top = 40
            api._getArtSections({ top: $scope.sectionTop, skip: 0 })
            api._getHighlightedCollections({ top: $scope.campaign.pagination.top, skip: 0, adminView }, 0, true)
          }).catch(ToastService.defaultErrorToast)
        }
      }

      if (collection.campaignId) {
        modalConfig.htmlDescription = CampaignService.getArchiveHtmlDescription(collection.campaignName)
      } else {
        modalConfig.description = $translate.instant('areYouSureArchiveCollection')
      }

      ConfirmationModalService.createModal(modalConfig)
    }

    $scope.editCollectionClick = function (collection) {
      api.getCreateCampaignDialogController().then(({ CreateCampaignDialogController }) => {
        ModalService.showModal({
          templateId: 'createCampaign.html',
          templateUrl: '/admin/dialogs/create-campaign/create-campaign-dialog.html?$$REVISION$$',
          destroyable: true,
          observeChanges: true,
          allowMultiple: true,
          controller: CreateCampaignDialogController,
          data: {
            collection,
            artCollectionId: collection.parentId
          }
        }).then(changed => {
          if (changed) {
            $scope.sectionTop = 5
            $scope.campaign.pagination.top = 40
            api._getArtSections({ top: $scope.sectionTop, skip: 0 })
            api._getHighlightedCollections({ top: $scope.campaign.pagination.top, skip: 0, adminView }, 0, true)
          }
        })
      })
    }

    $scope.closeArtFilters = function () {
      $scope.flags.showFilter = false
    }

    $scope.openFormatDialog = (sectionId) => {
      api.getArtSizeDialogController().then(({ ArtSizeDialogController }) => {
        const artSizeDialog = UdsModalService.createModal({
          controller: ArtSizeDialogController,
          modalName: 'artSizeDialog',
          data: {
            artCollectionId: sectionId
          }
        })

        artSizeDialog.open()
      })
    }

    function _addInfiniteScroll () {
      const container = $('.content-container-two-menu.dashboard')
      if (container.length) {
        container.scroll(() => {
          if (!$scope.loadingMoreSections && !$scope.sectionLoading && !$scope.search.state.searching && $scope.sectionsCount > $scope.sections.length && container.scrollTop() + container.innerHeight() >= container[0].scrollHeight - 1) {
            $scope.loadMoreSections()
          }
        })
      }
    }

    function _showTemplateSuggestions (product, template) {
      if (template.detailsId) {
        const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TEMPLATES_ID, [template.id])
        ConnectorWebService.get(url).then(function (templ) {
          if (templ && templ.details && templ.details.suggestions) {
            api.getTemplateSuggestionsDialogController().then(({ TemplateSuggestionsDialogController }) => {
              ModalService.showModal({
                templateId: 'templateSuggestions.html',
                templateUrl: '/arts/dialogs/template-suggestions/template-suggestions-dialog.html?$$REVISION$$',
                controller: TemplateSuggestionsDialogController,
                destroyable: true,
                data: {
                  _sSuggestions: templ.details.suggestions,
                  _bIsPrintInstruction: product && product.type === 'PRINTABLE'
                }
              })
            })
          }
        })
      }
    }

    async function _getSectionCollections (section, index, firstLoad, reloadSection = false) {
      return ArtCollectionsService.getCollectionsById(section.id, { top: $scope.filesTop, skip: $scope.filesTop * index })
        .catch(ToastService.defaultErrorToast)
        .then(collections => {
          if (firstLoad || reloadSection) {
            section.collections = []
            section.totalCollections = 0
          }

          section.collections.push(...collections.rows)
          section.totalCollections = parseInt(collections.count)

          if (collections.count) {
            $scope.areThereTemplates = true
          }

          if (firstLoad) {
            section.filesCount += parseInt(collections.count)
          }
        })
    }

    async function _getSectionTemplates (section, index, firstLoad, reloadSection = false) {
      return ArtCollectionsService.getTemplatesById(section.id, { top: $scope.filesTop, skip: $scope.filesTop * index })
        .catch(ToastService.defaultErrorToast)
        .then(templates => {
          if (firstLoad || reloadSection) {
            section.templates = []
            section.totalTemplates = 0
          }

          section.templates.push(...templates.rows)
          section.totalTemplates = parseInt(templates.count)

          if (templates.count) {
            $scope.areThereTemplates = true
          }

          if (firstLoad || reloadSection) {
            section.filesCount += parseInt(templates.count)
          }
        })
    }

    function _initSearchArtsPage (stateParams) {
      if (stateParams.search) {
        $scope.search.term = stateParams.search
      }
      if (stateParams.page) {
        api._nextSearchPage(stateParams.page, stateParams, true)
      } else {
        api._onSearchArts(stateParams.search, { ...stateParams })
      }
    }

    async function _onSearchArts (term, filters, pageToken) {
      if (filters && !Array.isArray(filters.artTagIds)) {
        filters.artTagIds = filters.artTagIds ? [filters.artTagIds] : []
      }

      const search = $scope.search
      const state = search.state
      const pagination = search.pagination

      const searchTerm = term || null
      const page = pageToken && pageToken !== 1 ? pageToken : null

      $location.search({ ...$state.params, ...filters, search: searchTerm, page })

      delete filters?.section

      const hasFilters = filters && Object.values(filters).some(api._checkEmptyValues)

      if ((!term && !hasFilters) || (!term && !$scope.filtersCount)) {
        if (state.searching) {
          api._clearSearch()
        }
        return
      }

      state.term = term
      state.searching = true
      state.loading = true
      pagination.collections.skip = 0
      pagination.templates.skip = 0

      const shouldSkipCollections =
        filters.customizationLevel ||
        filters.formatId ||
        filters.needApproval !== null ||
        filters.artTagIds.length > 0

      const templatePromise = ArtsService.search(state.term, pagination.templates.top, pagination.templates.skip, filters).catch((err) => {
        ToastService.defaultErrorToast()
        console.error(err) // if some error occurs, we are able to identify it throught a screenshot or a video
      })
      const collectionPromise = shouldSkipCollections
        ? Promise.resolve({ rows: [], count: 0 })
        : ArtCollectionsService.searchArtCollections(state.term, pagination.collections.top, pagination.collections.skip, false, false, filters).catch((err) => {
          ToastService.defaultErrorToast()
          console.error(err) // if some error occurs, we are able to identify it throught a screenshot or a video
        })

      $q.all([templatePromise, collectionPromise]).then(([templates, collections]) => {
        const safeTemplates = templates || { rows: [], count: 0 }
        const safeCollections = collections || { rows: [], count: 0 }

        search.templates = safeTemplates.rows
        search.collections = safeCollections.rows
        search.collectionCount = safeCollections.count
        search.templateCount = safeTemplates.count
        search.count = Number(safeTemplates.count) + Number(safeCollections.count)
      }).finally(() => {
        state.loading = false
      })
    }

    function _getHighlightedCollections (params, paginationIndex, cleanArray) {
      $scope.campaign.state.loading = true

      if (cleanArray) {
        $scope.campaign.results = []
        $scope.campaign.totalCount = 0
      }

      if (paginationIndex == null) {
        paginationIndex = 0
      }

      ArtCollectionsService.getHighlightedCollections(params)
        .catch(() => {
          ToastService.defaultErrorToast()
          $scope.campaign.state.loading = false
        })
        .then(res => {
          $scope.campaign.results.push(...res.rows)
          $scope.campaign.totalCount = res.count

          if ($scope.campaign.results.length) {
            $rootScope.isSecondLevelSidebarExpanded = true
          } else {
            $scope.hideSearch++
          }

          if (!$scope.$$phase) {
            $scope.$apply()
          }

          return $q.resolve()
        }).then(() => {
          if ($scope.campaign.totalCount > $scope.campaign.results.length) {
            paginationIndex++

            api._getHighlightedCollections({ top: $scope.campaign.pagination.top, skip: $scope.campaign.pagination.top * paginationIndex }, paginationIndex, false)
          } else {
            $scope.campaign.state.loading = false
          }
        }).finally(() => {
          if ($scope.campaign.state.loading) {
            return
          }

          const sidebarItems = []
          $scope.campaign.results.forEach(campaign => {
            campaign.countTemplates = parseInt(campaign.countTemplates)
            if ($rootScope.isUserSysAdminAdminDesigner() || !campaign.scheduledDate) {
              campaign.isScheduled = false
            } else {
              campaign.isScheduled = moment(campaign.scheduledDate) > today
            }

            if (campaign.scheduledDate) {
              campaign.showScheduledLabel = moment(campaign.scheduledDate) > today
            }

            if (!campaign.isScheduled && campaign.countFiles) {
              sidebarItems.push({
                title: campaign.title,
                id: campaign.id
              })
            }
          })

          if (sidebarItems.length > 0) {
            const campaign = {
              name: 'campaigns.title',
              row: sidebarItems
            }
            $scope.sidebar.items.unshift(campaign)
          }
        })
    }

    function _nextSearchPage (page, stateParams, fromParams) {
      let pageToken = Number(page)
      const search = $scope.search
      const pagination = search.pagination

      if (!fromParams || !pageToken) {
        pageToken = isNaN(pageToken) ? 1 : pageToken + 1
      }

      if (pageToken < 1) {
        pageToken = 1
      }

      $scope.currentPage = pageToken
      $scope.indexToken = pageToken - 1

      pagination.skip = (pageToken - 1) * pagination.top

      if (stateParams && stateParams.search) {
        api._onSearchArts(stateParams.search, { ...stateParams }, pageToken)
      } else {
        api._onSearchArts(search.state.term, $scope.filters, pageToken)
      }
    }

    function _checkEmptyValues (value) {
      if (Array.isArray(value) && value.length) {
        return true
      } else if (!Array.isArray(value) && value !== undefined && value !== null) {
        return true
      }

      return false
    }

    function _checkIfPageExists (count, top) {
      if (!count) {
        return
      }

      const paginationSize = Math.ceil(count / top)

      if ($scope.currentPage > paginationSize) {
        api._nextSearchPage(1, $state.params, true)
        ToastService.showErrorToast($translate.instant('thisPageDoesNotExist'))
      }
    }

    function _handleKeyboardNavigation () {
      document.addEventListener('keydown', api._handleNavigateThroughKeyboard)
    }

    function _handleQuickPreview () {
      Mousetrap.bind('space', api._handleOpenQuickPreview)
      document.addEventListener('click', api._clearSelectedTemplate)
    }

    function _handleNavigateThroughKeyboard (ev) {
      const isArrowLeft = ev.code === 'ArrowLeft'
      const isArrowRight = ev.code === 'ArrowRight'
      const isShiftPressed = ev.shiftKey === true
      const isModalOpen = ModalService.getCurrentModal()
      const isAssetPreviewOpen = AssetPreviewService.assetPreviewIsOpen()

      if ((!$scope.selectedTemplates.length && !$scope.selectedCollections.length) || isModalOpen || isAssetPreviewOpen) {
        return
      }

      const hasSelectedTemplate = $scope.selectedTemplates.length > 0
      const hasSelectedCollection = $scope.selectedCollections.length > 0

      let sectionId = null
      if (hasSelectedTemplate) {
        sectionId = $scope.selectedTemplates[$scope.selectedTemplates.length - 1].artCollectionId
      } else if (hasSelectedCollection) {
        sectionId = $scope.selectedCollections[$scope.selectedCollections.length - 1].parentId
      }

      let sectionTemplates = []
      let sectionCollections = []

      if ($scope.search.state.searching) {
        sectionTemplates = $scope.search.templates || []
        sectionCollections = $scope.search.collections || []
      } else if (sectionId) {
        const section = $scope.sections.find(s => s.id === sectionId)
        if (section) {
          sectionTemplates = section.templates || []
          sectionCollections = section.collections || []
        }
      }

      const templatesCount = sectionTemplates.length
      const collectionsCount = sectionCollections.length
      const currentSelectedTemplateIndex = hasSelectedTemplate ? sectionTemplates.findIndex((template) => template.id === $scope.selectedTemplates[$scope.selectedTemplates.length - 1].id) : -1
      const currentSelectedCollectionIndex = hasSelectedCollection ? sectionCollections.findIndex((collection) => collection.id === $scope.selectedCollections[$scope.selectedCollections.length - 1].id) : -1

      if (isShiftPressed) {
        let lastSelectionDirection = ''

        if ($scope.selectedTemplates.length > 1) {
          const lastIndex = sectionTemplates.findIndex(template => template.id === $scope.selectedTemplates[$scope.selectedTemplates.length - 1].id)
          const secondLastIndex = sectionTemplates.findIndex(template => template.id === $scope.selectedTemplates[$scope.selectedTemplates.length - 2].id)

          if (lastIndex > secondLastIndex) {
            lastSelectionDirection = 'right'
          } else if (lastIndex < secondLastIndex) {
            lastSelectionDirection = 'left'
          }
        } else if ($scope.selectedCollections.length > 1) {
          const lastIndex = sectionCollections.findIndex(collection => collection.id === $scope.selectedCollections[$scope.selectedCollections.length - 1].id)
          const secondLastIndex = sectionCollections.findIndex(collection => collection.id === $scope.selectedCollections[$scope.selectedCollections.length - 2].id)

          if (lastIndex > secondLastIndex) {
            lastSelectionDirection = 'right'
          } else if (lastIndex < secondLastIndex) {
            lastSelectionDirection = 'left'
          }
        }

        if (lastSelectionDirection === 'left' && isArrowRight) {
          if (hasSelectedCollection && $scope.selectedCollections.length > 0) {
            api._unselectLastItemFromSelectedItems('collection')
            return
          } else if (hasSelectedTemplate && $scope.selectedTemplates.length > 0) {
            api._unselectLastItemFromSelectedItems('template')
            return
          }
        } else if (lastSelectionDirection === 'right' && isArrowLeft) {
          if (hasSelectedTemplate && $scope.selectedTemplates.length > 0) {
            api._unselectLastItemFromSelectedItems('template')
            return
          } else if (hasSelectedCollection && $scope.selectedCollections.length > 0) {
            api._unselectLastItemFromSelectedItems('collection')
            return
          }
        }

        // Specific case for when there is only one template selected and multiple collections selected
        // The opposite case also occurs, which is why this specific validation is needed

        if ($scope.selectedTemplates.length === 1 &&
          $scope.selectedCollections.length > 0 &&
          (lastSelectionDirection === '' || lastSelectionDirection === null) &&
          isArrowLeft &&
          !$scope.selectedTemplates[0].firstSelection
        ) {
          api._unselectLastItemFromSelectedItems('template')
        }

        if ($scope.selectedCollections.length === 1 &&
          $scope.selectedTemplates.length > 0 &&
          (lastSelectionDirection === '' || lastSelectionDirection === null) &&
          isArrowRight &&
          !$scope.selectedCollections[0].firstSelection
        ) {
          api._unselectLastItemFromSelectedItems('collection')
        }

        if (isArrowLeft) {
          if (hasSelectedTemplate && currentSelectedTemplateIndex > 0) {
            const previousTemplate = sectionTemplates[currentSelectedTemplateIndex - 1]
            api._addNewItemToSelectedItems(previousTemplate, 'template')
          } else if (hasSelectedTemplate &&
            currentSelectedTemplateIndex === 0 &&
            collectionsCount > 0 &&
            currentSelectedCollectionIndex === -1) {
            const lastCollection = sectionCollections[collectionsCount - 1]
            api._addNewItemToSelectedItems(lastCollection, 'collection')
          } else if (hasSelectedCollection && currentSelectedCollectionIndex > 0) {
            const previousCollection = sectionCollections[currentSelectedCollectionIndex - 1]
            api._addNewItemToSelectedItems(previousCollection, 'collection')
          }
        } else if (isArrowRight) {
          if (hasSelectedTemplate && currentSelectedTemplateIndex < templatesCount - 1) {
            const nextTemplate = sectionTemplates[currentSelectedTemplateIndex + 1]
            api._addNewItemToSelectedItems(nextTemplate, 'template')
          } else if (hasSelectedCollection && currentSelectedCollectionIndex < collectionsCount - 1) {
            const nextCollection = sectionCollections[currentSelectedCollectionIndex + 1]
            api._addNewItemToSelectedItems(nextCollection, 'collection')
          } else if (hasSelectedCollection &&
            currentSelectedCollectionIndex === collectionsCount - 1 &&
            templatesCount > 0 &&
            currentSelectedTemplateIndex === -1) {
            const firstTemplate = sectionTemplates[0]
            api._addNewItemToSelectedItems(firstTemplate, 'template')
          }
        }
      } else {
        if (isArrowLeft) {
          if (hasSelectedTemplate && currentSelectedTemplateIndex > 0) {
            const previousTemplate = sectionTemplates[currentSelectedTemplateIndex - 1]
            api._unselectAllAndSelectNewItem(previousTemplate, 'template')
          } else if (hasSelectedTemplate && currentSelectedTemplateIndex === 0 && collectionsCount > 0) {
            const lastCollection = sectionCollections[collectionsCount - 1]
            api._unselectAllAndSelectNewItem(lastCollection, 'collection')
          } else if (hasSelectedCollection && currentSelectedCollectionIndex > 0) {
            const previousCollection = sectionCollections[currentSelectedCollectionIndex - 1]
            api._unselectAllAndSelectNewItem(previousCollection, 'collection')
          }
        } else if (isArrowRight) {
          if (hasSelectedTemplate && currentSelectedTemplateIndex < templatesCount - 1) {
            const nextTemplate = sectionTemplates[currentSelectedTemplateIndex + 1]
            api._unselectAllAndSelectNewItem(nextTemplate, 'template')
          } else if (hasSelectedCollection && currentSelectedCollectionIndex < collectionsCount - 1) {
            const nextCollection = sectionCollections[currentSelectedCollectionIndex + 1]
            api._unselectAllAndSelectNewItem(nextCollection, 'collection')
          } else if (hasSelectedCollection && currentSelectedCollectionIndex === collectionsCount - 1 && templatesCount > 0) {
            const firstTemplate = sectionTemplates[0]
            api._unselectAllAndSelectNewItem(firstTemplate, 'template')
          }
        }
      }
    }

    function _unselectAllAndSelectNewItem (newSelectedItem, itemType) {
      api._unselectAllTemplatesAndCollections()
      newSelectedItem.selected = true
      if (itemType === 'template') {
        $scope.selectedTemplates.push(newSelectedItem)
      } else if (itemType === 'collection') {
        $scope.selectedCollections.push(newSelectedItem)
      }
      $scope.$apply()
    }

    function _addNewItemToSelectedItems (newSelectedItem, itemType) {
      newSelectedItem.selected = true
      if (itemType === 'template') {
        $scope.selectedTemplates.push(newSelectedItem)
      } else if (itemType === 'collection') {
        $scope.selectedCollections.push(newSelectedItem)
      }
      $scope.$apply()
    }

    function _unselectLastItemFromSelectedItems (itemType) {
      let lastItem = null
      if (itemType === 'template') {
        lastItem = $scope.selectedTemplates.pop()
      } else if (itemType === 'collection') {
        lastItem = $scope.selectedCollections.pop()
      }
      lastItem.selected = false
      $scope.$apply()
    }

    function _openTemplatePropertiesDialog (assetsToAttach, collectionId) {
      const assetsDetailsPromises = assetsToAttach.map((asset) => NewAssetService.getAssetDetails(asset.id, { formatData: 'raw' }))

      Promise.all(assetsDetailsPromises).then((assetsDetails) => {
        const bulkTemplates = assetsToAttach.length > 1
        api.getTemplatePropertiesDialogController().then(({ TemplatePropertiesDialogController }) => {
          const templatePropertiesDialog = UdsModalService.createModal({
            controller: TemplatePropertiesDialogController,
            modalName: 'templatePropertiesDialog',
            data: {
              bulkTemplates,
              assets: assetsDetails,
              isCustomizable: false,
              artCollectionId: collectionId
            }
          })

          templatePropertiesDialog.open()
        })
      })
    }

    function _handleOpenQuickPreview (ev) {
      const isSpaceBar = ev.code !== 'Space' && ev.keyCode !== 32
      if (isSpaceBar || ev.repeat || !$scope.selectedTemplates.length) {
        return
      }

      if (!AssetPreviewService.assetPreviewIsOpen() && AssetPreviewService.assetQuickPreviewIsOpen()) {
        ev.preventDefault()
        AssetPreviewService.closePreview()
        return
      }

      if (!AssetPreviewService.assetPreviewIsOpen() && !AssetPreviewService.assetQuickPreviewIsOpen()) {
        ev.preventDefault()
        AssetPreviewService.openAssetQuickPreview({
          currentAsset: $scope.selectedTemplates[$scope.selectedTemplates.length - 1],
          assets: $scope.search.templates?.length ? $scope.search.templates : api._getSelectedTemplateSection($scope.selectedTemplates[$scope.selectedTemplates.length - 1])
        })
      }
    }

    function _getSelectedTemplateSection (template) {
      const assets = $scope.sections.find((section) => section.id === template.artCollectionId)
      return assets.templates
    }

    function _clearSelectedTemplate (ev) {
      const isTemplateCard = ev.target.closest('template-item')

      if (!isTemplateCard && !AssetPreviewService.assetPreviewIsOpen()) {
        $timeout(() => {
          if ($scope.selectedTemplate) {
            $scope.selectedTemplate.selected = false
            $scope.selectedTemplate = null
          }
        })
      }
    }

    function _onFilter (filters) {
      $scope.filters = filters
      api._nextSearchPage($state.params)
    }

    $scope.handleOpenQuickPreview = (event) => api._handleOpenQuickPreview(event)

    $scope.handleFilterSearchClick = () => {
      $scope.flags.showFilter = !$scope.flags.showFilter
    }

    $scope.handleSubmitSearch = api._onSearch

    $scope.setFilters = (filters) => {
      $scope.flags.showFilter = false
      $(document).scrollTop(0)
      $scope.search.pagination.skip = 0
      $scope.search.pagination.templates.skip = 0
      $scope.search.pagination.collections.skip = 0
      $scope.indexToken = 0
      $scope.filters = filters

      if (filters || $scope.search.term) {
        SegmentService.track('arts-search-module', {
          search_text: $scope.search.term,
          search_category: filters?.artTagIds,
          search_format: filters?.formatId,
          search_approval: filters?.needApproval,
          search_level: filters?.customizationLevel,
          search_group: filters?.groupId,
          search_arquived: filters?.isArchived
        })
      }
      api._onSearchArts($scope.search.term, filters, 0)
    }

    $scope.isPreviewEnabled = AssetPreviewService.isPreviewEnabled

    function _onSearch (term) {
      api._unselectAllTemplatesAndCollections()
      $scope.search.term = term
      $scope.setFilters($scope.filters)
    }

    function _onCount (count) {
      $scope.filtersCount = count
    }

    function _initHeader () {
      const isNotUserRole = $rootScope.isUserSysAdminAdminDesigner()
      $scope.pageTitle = $translate.instant('allMaterials')

      const exhibitDefaultValue = {
        label: $translate.instant('actives'),
        value: false,
        icon: 'success',
        active: true,
        disabled: false
      }

      const isArchived = isNotUserRole ? {
        name: 'isArchived',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: exhibitDefaultValue,
        props: {
          label: $translate.instant('exhibit'),
          multiple: false,
          switchMode: true,
          udsDisabled: false,
          options: [
            exhibitDefaultValue,
            {
              label: $translate.instant('archivedPlural'),
              value: true,
              icon: 'archive',
              active: false,
              disabled: false
            }
          ]
        }
      } : null

      const customizationLevel = $scope.companyFeatures.artsCustomization.access ? {
        name: 'customizationLevel',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: null,
        props: {
          label: $translate.instant('customizationLevel'),
          multiple: false,
          switchMode: false,
          udsDisabled: false,
          options: [
            {
              label: $translate.instant('permissionFree'),
              value: 'FREE_STYLE',
              icon: 'unlock',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('permissionRestricted'),
              value: 'RESTRICTED',
              icon: 'lock',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('customizable'),
              value: 'CUSTOMIZABLE',
              icon: 'lock-filled',
              active: false,
              disabled: false
            }
          ]
        }
      } : null

      const needApproval = $scope.companyFeatures.artsCustomization.access ? {
        name: 'needApproval',
        type: 'FILTER_BUTTON_SELECT',
        grouped: false,
        defaultValue: null,
        props: {
          label: $translate.instant('templates'),
          multiple: false,
          switchMode: false,
          udsDisabled: false,
          options: [
            {
              label: $translate.instant('withApproval'),
              value: true,
              icon: 'check',
              active: false,
              disabled: false
            },
            {
              label: $translate.instant('withoutApproval'),
              value: false,
              icon: 'close',
              active: false,
              disabled: false
            }
          ]
        }
      } : null

      const groups = isNotUserRole ? {
        name: 'groupId',
        type: 'INPUT_SELECT',
        grouped: true,
        defaultValue: null,
        props: {
          label: $translate.instant('userGroup'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'text',
          hasMoreOptions: false,
          udsDisabled: false,
          pricing: false,
          pricingTooltip: '',
          pricingTooltipPosition: 'top',
          options: []
        },
        loadData: (searchTerm, top, skip) => GroupService.getGroups(top, skip, { searchTerm })
      } : null

      const createdAt = isNotUserRole ? {
        name: 'createdAtRange',
        type: 'DATE_RANGE_PICKER',
        grouped: true,
        defaultValue: $scope.filters.createdAtStart ? {
          start: $scope.filters.createdAtStart,
          end: $scope.filters.createdAtEnd
        } : '',
        props: {
          locale: $rootScope.oUser.locale,
          label: $translate.instant('creationDate'),
          firstDayOfWeek: '1',
          direction: 'right'
        }
      } : null

      const templateExpiration = isNotUserRole ? {
        name: 'templateExpirationRange',
        type: 'DATE_RANGE_PICKER',
        grouped: true,
        defaultValue: $scope.filters.templateExpirationStart ? {
          start: $scope.filters.templateExpirationStart,
          end: $scope.filters.templateExpirationEnd
        } : '',
        props: {
          locale: $rootScope.oUser.locale,
          label: $translate.instant('expiration'),
          firstDayOfWeek: '1',
          direction: 'right'
        }
      } : null

      const campaignFilter = $rootScope.isGuest() ? null : {
        name: 'campaignId',
        type: 'INPUT_SELECT',
        grouped: false,
        defaultValue: null,
        props: {
          label: $translate.instant('campaignsModule.single'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'text',
          hasMoreOptions: false,
          udsDisabled: false,
          pricing: false,
          pricingTooltip: '',
          pricingTooltipPosition: 'top',
          options: []
        },
        loadData: (search, top, skip) => CampaignService.getAllCampaigns({ search, top, skip, isArchived: false })
      }

      const filters = [
        isArchived,
        customizationLevel,
        needApproval,
        {
          name: 'artTagIds',
          type: 'INPUT_MULTISELECT',
          grouped: false,
          defaultValue: [],
          props: {
            label: $translate.instant('filterByTags'),
            placeholder: $translate.instant('selectPlaceholder'),
            emptyMsg: $translate.instant('noResults'),
            loadButtonLabel: '',
            type: 'tag',
            hasMoreOptions: false,
            udsDisabled: false,
            options: []
          },
          loadData: (name, top, skip) => TagsService.getTags({ name, top, skip })
        },
        campaignFilter,
        {
          name: 'formatId',
          type: 'INPUT_SELECT',
          grouped: isNotUserRole,
          defaultValue: null,
          props: {
            label: $translate.instant('product'),
            placeholder: $translate.instant('selectPlaceholder'),
            emptyMsg: $translate.instant('noResults'),
            type: 'text',
            hasMoreOptions: false,
            udsDisabled: false,
            pricing: false,
            pricingTooltip: '',
            pricingTooltipPosition: 'top',
            options: []
          },
          loadData: (search, top, skip) => FormatsService.getFormats({ search, top, skip })
        },
        groups,
        createdAt,
        templateExpiration
      ].filter(Boolean)

      const rightButtons = [
        {
          type: 'analytics',
          module: 'arts-templates'
        }
      ]

      if (isNotUserRole) {
        const editButton = {
          type: 'button',
          btnType: 'secondary',
          label: $translate.instant('edit'),
          icon: 'edit',
          onClick: api._handleEditMode
        }

        rightButtons.push(editButton)
      }

      $scope.headerToolbar = {
        rightButtons,
        search: {
          filters: filters.filter(Boolean),
          onFilter: api._onFilter,
          onSearch: api._onSearch,
          onCount: api._onCount
        }
      }
    }

    function _handleEditMode () {
      $rootScope.isSecondLevelSidebarExpanded = false
      $state.go('arts.templatesEdit')
    }

    function _handleCompanyFeatures () {
      return $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
        const customizableArtsSlug = String('ARTS.CUSTOMIZABLE_ARTS')
        $scope.companyFeatures.artsCustomization.access = !!features[customizableArtsSlug]
      })
    }

    async function _showSocialMediaIntegrationModal () {
      const isEnableSocialMedia = await $rootScope.getEnableSocialMedia(true)

      const isNotEnableSocialMedia = !isEnableSocialMedia

      if (isNotEnableSocialMedia) {
        const featureSlug = 'SOCIAL_MEDIA_MODAL'

        FeatureReleaseNotificationsService.getUserNotificationOption(featureSlug)
          .then(api._successGetSocialMediaIntegration)
          .catch(api._errorGetSocialMediaIntegration)
      }
    }

    function _openSocialMediaIntegration () {
      api.getSocialMediaIntegrationController().then(({ SocialMediaIntegrationController }) => {
        const socialMediaIntegration = UdsModalService.createModal({
          controller: SocialMediaIntegrationController,
          modalName: 'socialMediaIntegrationDialog'
        })

        socialMediaIntegration.open()
      })
    }

    function _successGetSocialMediaIntegration (didIntegration) {
      const isAdmin = $rootScope.isUserSysAdminAdmin()
      const didNotIntegration = !didIntegration
      const hasNotIntegrationDate = !api._hasNewIntegrationDate()

      if (isAdmin && didNotIntegration && hasNotIntegrationDate) {
        return api._openSocialMediaIntegration()
      }
    }

    function _errorGetSocialMediaIntegration (error) {
      console.log({ error })
      ToastService.defaultErrorToast()
    }

    function _hasNewIntegrationDate () {
      const newIntegrationDate = LocalStorageService.get('socialMedia.allowIntegrationHide')

      if (!newIntegrationDate) {
        return false
      }

      const currentDate = new Date()
      const hasNewIntegrationDate = new Date(newIntegrationDate) > currentDate

      return hasNewIntegrationDate
    }

    function _unselectAllTemplatesAndCollections () {
      $scope.selectedTemplates.forEach(template => {
        template.firstSelection = false
        template.selected = false
      })

      $scope.selectedCollections.forEach(collection => {
        collection.firstSelection = false
        collection.selected = false
      })

      $scope.selectedTemplates = []
      $scope.selectedCollections = []
    }

    $scope.handleTemplateClick = function (template, event) {
      const isShiftPressed = event && event.shiftKey
      const isFromDifferentSection =
          ($scope.selectedTemplates && $scope.selectedTemplates.length > 0 &&
           template.artCollectionId &&
           $scope.selectedTemplates[0].artCollectionId !== template.artCollectionId) ||
          ($scope.selectedCollections && $scope.selectedCollections.length > 0 &&
           template.artCollectionId &&
           $scope.selectedCollections[0].parentId !== template.artCollectionId)

      if (isFromDifferentSection) {
        api._unselectAllTemplatesAndCollections()
        template.firstSelection = true
        template.selected = true
        $scope.selectedTemplates.push(template)
      } else {
        if (template.selected) {
          template.firstSelection = false
          template.selected = false
          $scope.selectedTemplates = $scope.selectedTemplates.filter(t => t.id !== template.id)
        } else {
          if ($scope.selectedTemplates.length === 0 && $scope.selectedCollections.length === 0) {
            template.firstSelection = true
          }

          if (isShiftPressed) {
            return api._handleShiftClickOnTemplate(template)
          }

          template.selected = true
          $scope.selectedTemplates.push(template)
        }
      }
    }

    $scope.handleCollectionClick = function (collection, event) {
      const isShiftPressed = event && event.shiftKey
      const isFromDifferentSection =
          ($scope.selectedTemplates && $scope.selectedTemplates.length > 0 &&
           collection.parentId &&
           $scope.selectedTemplates[0].artCollectionId !== collection.parentId) ||
          ($scope.selectedCollections && $scope.selectedCollections.length > 0 &&
           collection.parentId &&
           $scope.selectedCollections[0].parentId !== collection.parentId)

      if (isFromDifferentSection) {
        api._unselectAllTemplatesAndCollections()
        collection.firstSelection = true
        collection.selected = true
        $scope.selectedCollections.push(collection)
      } else {
        if (collection.selected) {
          collection.firstSelection = false
          collection.selected = false
          $scope.selectedCollections = $scope.selectedCollections.filter(c => c.id !== collection.id)
        } else {
          if ($scope.selectedCollections.length === 0 && $scope.selectedTemplates.length === 0) {
            collection.firstSelection = true
          }

          if (isShiftPressed) {
            return api._handleShiftClickOnCollection(collection)
          }

          collection.selected = true
          $scope.selectedCollections.push(collection)
        }
      }
    }

    $scope.handleTemplateClickSearch = function (template, event) {
      const isShiftPressed = event && event.shiftKey
      if (template.selected) {
        template.firstSelection = false
        template.selected = false
        $scope.selectedTemplates = $scope.selectedTemplates.filter(t => t.id !== template.id)
      } else {
        if ($scope.selectedTemplates.length === 0 && $scope.selectedCollections.length === 0) {
          template.firstSelection = true
        }

        if (isShiftPressed) {
          return api._handleShiftClickOnTemplate(template, true)
        }
        template.selected = true
        $scope.selectedTemplates.push(template)
      }
    }

    $scope.handleCollectionClickSearch = function (collection, event) {
      const isShiftPressed = event && event.shiftKey
      if (collection.selected) {
        collection.firstSelection = false
        collection.selected = false
        $scope.selectedCollections = $scope.selectedCollections.filter(c => c.id !== collection.id)
      } else {
        if ($scope.selectedCollections.length === 0 && $scope.selectedTemplates.length === 0) {
          collection.firstSelection = true
        }

        if (isShiftPressed) {
          return api._handleShiftClickOnCollection(collection, true)
        }
        collection.selected = true
        $scope.selectedCollections.push(collection)
      }
    }

    $scope.unselectAllAssets = () => api._unselectAllTemplatesAndCollections()

    $scope.getMainContent = (section) => {
      return $(`.products-list-content .products-row#section-${section.id}`)[0]
    }

    $scope.handleDropMaterials = (files, sectionId) => {
      sectionId = parseInt(sectionId)
      MaterialUploadService.uploadMaterials(files, sectionId, api._openTemplatePropertiesDialog)
    }

    function _handleShiftClickOnTemplate (template, search = false) {
      document.getSelection().removeAllRanges()
      SelectMaterialCollectionService.unselectAllExceptFirstSelected($scope.selectedTemplates, $scope.selectedCollections)

      const firstSelectedTemplate = $scope.selectedTemplates.find(t => t.firstSelection)
      const firstSelectedCollection = $scope.selectedCollections.find(c => c.firstSelection)
      let sectionTemplates = []
      let sectionCollections = []
      const sectionId = firstSelectedTemplate?.artCollectionId || firstSelectedCollection?.parentId

      if (search) {
        sectionTemplates = $scope.search.templates || []
        sectionCollections = $scope.search.collections || []
      } else if (sectionId) {
        const section = $scope.sections.find(s => s.id === sectionId)
        if (section) {
          sectionTemplates = section.templates || []
          sectionCollections = section.collections || []
        }
      }

      const indexOfClickedTemplate = sectionTemplates.indexOf(template)

      if (firstSelectedTemplate) {
        const indexOfFirstSelectedTemplate = sectionTemplates.indexOf(firstSelectedTemplate)
        const startIndex = Math.min(indexOfFirstSelectedTemplate, indexOfClickedTemplate)
        const endIndex = Math.max(indexOfFirstSelectedTemplate, indexOfClickedTemplate) + 1
        const templatesToSelect = sectionTemplates.slice(startIndex, endIndex)

        templatesToSelect.forEach(t => {
          t.selected = true
        })
        $scope.selectedTemplates = [...templatesToSelect]
      } else if (firstSelectedCollection) {
        const indexOfFirstSelectedCollection = sectionCollections.indexOf(firstSelectedCollection)
        const collectionsToSelect = sectionCollections.slice(indexOfFirstSelectedCollection, (sectionCollections.length))
        const templatesToSelect = sectionTemplates.slice(0, indexOfClickedTemplate + 1)

        collectionsToSelect.forEach(c => {
          c.selected = true
        })
        templatesToSelect.forEach(t => {
          t.selected = true
        })

        $scope.selectedCollections = [...collectionsToSelect]
        $scope.selectedTemplates = [...templatesToSelect]
      }
    }

    function _handleShiftClickOnCollection (collection, search = false) {
      document.getSelection().removeAllRanges()
      SelectMaterialCollectionService.unselectAllExceptFirstSelected($scope.selectedTemplates, $scope.selectedCollections)

      const firstSelectedTemplate = $scope.selectedTemplates.find(t => t.firstSelection)
      const firstSelectedCollection = $scope.selectedCollections.find(c => c.firstSelection)
      let sectionTemplates = []
      let sectionCollections = []
      const sectionId = firstSelectedTemplate?.artCollectionId || firstSelectedCollection?.parentId

      if (search) {
        sectionTemplates = $scope.search.templates || []
        sectionCollections = $scope.search.collections || []
      } else if (sectionId) {
        const section = $scope.sections.find(s => s.id === sectionId)
        if (section) {
          sectionTemplates = section.templates || []
          sectionCollections = section.collections || []
        }
      }

      const indexOfClickedCollection = sectionCollections.indexOf(collection)

      if (firstSelectedCollection) {
        const indexOfFirstSelectedCollection = sectionCollections.indexOf(firstSelectedCollection)
        const startIndex = Math.min(indexOfFirstSelectedCollection, indexOfClickedCollection)
        const endIndex = Math.max(indexOfFirstSelectedCollection, indexOfClickedCollection) + 1
        const collectionsToSelect = sectionCollections.slice(startIndex, endIndex)

        collectionsToSelect.forEach(c => {
          c.selected = true
        })
        $scope.selectedCollections = [...collectionsToSelect]
      } else if (firstSelectedTemplate) {
        const indexOfFirstSelectedTemplate = sectionTemplates.indexOf(firstSelectedTemplate)
        const templatesToSelect = sectionTemplates.slice(0, indexOfFirstSelectedTemplate + 1)
        const collectionsToSelect = sectionCollections.slice(indexOfClickedCollection, (sectionCollections.length))

        collectionsToSelect.forEach(c => {
          c.selected = true
        })
        templatesToSelect.forEach(t => {
          t.selected = true
        })

        $scope.selectedCollections = [...collectionsToSelect]
        $scope.selectedTemplates = [...templatesToSelect]
      }
    }

    $scope.shareCollectionClick = function (collection) {
      api.getShareFolderDialogController().then(({ ShareFolderDialogController }) => {
        const shareFolderDialog = UdsModalService.createModal({
          controller: ShareFolderDialogController,
          modalName: 'shareFolderDialog',
          data: {
            collection: collection
          },
          onClose: null
        })

        shareFolderDialog.open()
      })
    }
  }
})()
